import { Link } from "react-router-dom";
import { Container } from "@/components/common/Container";
import { Logo } from "@/components/common/Logo";
import { CtaButton } from "@/components/common/CtaButton";
import { footerNav, socialLinks } from "@/data/navigation";
import { siteConfig } from "@/config/site.config";
import { Mail, MapPin } from "@/icons";

/** Global site footer with grouped navigation + CTA band. */
export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-secondary text-slate-300"
    >
      <Container className="py-16 lg:py-20">
        {/* CTA band */}
        <div className="flex flex-col gap-8 rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-8 sm:p-12 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Ready to Start Your Digital Transformation Journey?
            </h2>
            <p className="mt-3 text-slate-400">
              Whether you need a modern website, enterprise software, AI-powered automation or 
              a complete digital transformation, our experts are ready to help.
            </p>
          </div>
          <CtaButton
            to={siteConfig.primaryCta.path}
            size="lg"
            withArrow
            magnetic
            data-testid="footer-cta"
          >
            {siteConfig.primaryCta.label}
          </CtaButton>
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="space-y-5">
            <Logo tone="invert" />
            <p className="max-w-xs text-sm leading-relaxed text-slate-400">
              {siteConfig.description}
            </p>
            {/* <div className="flex items-center gap-3">
              {socialLinks.map(({ label, href, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-300 transition-colors hover:border-accent hover:text-accent"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div> */}
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                {group.title}
              </h3>
              <ul className="mt-4 space-y-3">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteConfig.legalName}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span className="inline-flex items-center gap-2">
              <Mail className="h-4 w-4" /> {siteConfig.contact.email}
            </span>
            <span className="inline-flex items-center gap-2">
              <MapPin className="h-4 w-4" /> {siteConfig.contact.address}
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
}
